var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link",style:({ maxHeight: _vm.col.maxHeight }),attrs:{"title":_vm.text}},[_c('span',{on:{"click":_vm.clickHandler}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }